import { storeConfig } from '@/shared/storeConfig';

export const useSmarticoLevels = defineStore(
  'smarticoLevels',
  () => {
    const { debugLog } = useSmarticoConfigs();

    const allLevels = ref<TLevel[]>();

    async function loadLevels() {
      try {
        const levelsData = await window._smartico.api.getLevels();

        allLevels.value = levelsData.sort(
          (a: TLevel, b: TLevel) => a.required_points - b.required_points,
        );

        debugLog('allLevels:', allLevels.value);
      } catch (err: any) {
        debugLog(`⭕️ ~ getLevels ~ ${err.toString()}`);
      }
    }

    return {
      allLevels,
      loadLevels,
    };
  },

  storeConfig,
);
